// extracted by mini-css-extract-plugin
export default {"user":"UsersSelector_user__INUNf"};